module.exports = __webpack_public_path__ + "img/mx_100.c0e6786b.png";